"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_router_dom_1 = require("react-router-dom");

var styles = tslib_1.__importStar(require("./CardLink.style"));

function CardLink(_a) {
  var className = _a.className,
      children = _a.children,
      isCSRLink = _a.isCSRLink,
      attributes = tslib_1.__rest(_a, ["className", "children", "isCSRLink"]);

  if (!attributes.href) {
    return jsx_runtime_1.jsx(react_1.Fragment, {
      children: children
    }, void 0);
  }

  return jsx_runtime_1.jsx(react_1.Fragment, {
    children: isCSRLink ? jsx_runtime_1.jsx(react_router_dom_1.Link, Object.assign({
      className: className,
      css: styles.wrapper,
      to: attributes.href
    }, {
      children: children
    }), void 0) : jsx_runtime_1.jsx("a", Object.assign({
      className: className,
      css: styles.wrapper
    }, attributes, {
      children: children
    }), void 0)
  }, void 0);
}

exports.default = react_1.memo(CardLink);